let parameters = {
    tableName: {
        label: 'Table Name',
        source: 'parameters.never',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: '',
        display: false,
        wait: false
    },
    template: {
        label: 'Template',
        source: 'parameters.never',
        class: 'xs12 sm12 d-flex',
        type: 'textarea',
        value: '',
        display: false,
        wait: false
    }
};

export default parameters;
